export const getCssPropertyValue = (value: string) =>
  getComputedStyle(document.documentElement).getPropertyValue(value)
